import { Link } from "react-router-dom";

// const appURL = "/task-tracker";
const year = new Date().getFullYear();

const About = ({ appURL }) => {
  return (
    <div className="about">
      <h4>Version 1.0.0</h4>
      <p>Created by Justin W</p>
      <br />
      <p>Copyright &copy; {year}</p>
      <Link to={appURL + "/"}>Back</Link>
    </div>
  );
};

export default About;
